import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CasillaActualService } from 'src/app/services/casilla-actual.service';
import { Router, ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment';
import { UsuariosService } from 'src/app/services/usuarios.service';
import { ToastService } from 'src/app/shared/services/toast.service';
import * as CryptoJS from 'crypto-js';
import { PaisModel } from '../home/store/registro-usuario.store.model';
import { TipoDocumentoPaisModel, LoginPortalRequest } from '../home/store/registro-usuario.store.model';

import { AppStore } from 'src/app/core/store/app.store';
import { LoginSigoRequest } from 'src/app/pages/login/login.store.model';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  isLoading:boolean = false;
  VALOR_MAXIMO_REPCATCHA = 4;
  errorRepcatcha: boolean = false;
  textoErrorRepcatcha: string = "";

  captchaTextNumber: any = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
  captchaText: any = []
  captchaEnteredArray: any[] = [];
  captchaEntered: String = ""

  loading = false;
  form: FormGroup;
  cargando: boolean = true;
  private ESTADOCASILLA = {
    REGISTRADOR: 1,
    ACTIVO: 2
  }

  loginPortalRequest: LoginPortalRequest

  isTypeP1bol = false;
  isTypeP2bol = false;
  isTypeP3bol = false;

  isTypeP1 = "password"
  isTypeP2 = "password"
  isTypeP3 = "password"

  datosUsuario: {
    nroDocumento: string,
    clave: string
  } = {
      nroDocumento: "",
      clave: ""
    }

  paises: PaisModel[];
  selectedPais: number;

  tipoDocumentoPais: TipoDocumentoPaisModel[];
  selectedTipDocPais: number;

  tipDocPN: TipoDocumentoPaisModel[];
  selectTipDocPN: number;

  urlReturn: string = "";

  loginSigoRequest: LoginSigoRequest;

  constructor(
    private appStore: AppStore,
    private activedRoute: ActivatedRoute,

    private fb: FormBuilder,
    // private casillaService: CasillaService,
    private casillaActual: CasillaActualService,
    private router: Router,
    private route: ActivatedRoute,
    private usuariosService: UsuariosService,
    private toast: ToastService
  ) {
    this.addStyleSheet();
  }

  save(): void {
    // this.loading = true;
    this.isLoading = true;
  }

  addStyleSheet() {
    var headID = document.getElementsByTagName('head')[0];
    var link = document.createElement('link');
    link.type = 'text/css';
    link.rel = 'stylesheet';
    link.id = 'widget_styles';
    headID.appendChild(link);
    link.href = '../assets/css/login/style.css';
  }
  ngOnInit() {

    console.log('LOGIN PRINCIPAL!!')
    var str = this.router.url;
    var splitted = str.split("ReturnUrl=", 2);
    this.urlReturn = splitted[1];
    // this.urlReturn = this.urlReturn.replace("%2F%2F", "//");
    this.urlReturn = this.urlReturn.replace(/%2F/g, "/");

    this.generateCaptcha();
    //console.log("url",this.urlReturn);

    // if (this.appStore.sessionAction.esSesionValida()) {
    //   this.router.navigate(['/dashboard/']);
    // }
    // else {
    //   let token = this.route.snapshot.queryParamMap.get('token');
    //   //console.log(token);
    //   if (token) {
    //     this.casillaActual.setSesion(token);
    //     const sesion = this.casillaActual.getSesion();
    //     this.router.navigate(['/dashboard/']);
    //     //location.href = "http://localhost:5000/dashboard";
    //   }
    //   else {
    //     this.router.navigate(['/login/']);
    //     //location.href = "http://localhost:5000/dashboard"; //environment.loginUrl + window.location.origin;
    //   }
    // }


    /*console.log(this.appStore.sessionAction.esSesionValida());
    if (this.appStore.sessionAction.esSesionValida()) 
    {
      //this.appStore.sessionAction.restablecerSesionDeLocalStorage();
      this.router.navigate(['/dashsboard/']);
    } 
    else 
    {
      const token = this.activedRoute.snapshot.queryParamMap.get('token');
      let token2 = this.route.snapshot.queryParamMap.get('token');
      console.log(token);
      console.log(token2);
      if (token) 
      {
        this.appStore.sessionAction.login(token);

        this.router.navigate(['/dashsboard/']);
      } 
      else 
      {
        console.log(location.origin);
        location.href = environment.loginUrl + location.origin;
        //location.href = 'http://localhost:5000/'
        //this.router.navigate(['/dashsboard/']);
      }
    }*/


    this.selectedTipDocPais = 0;
    this.selectedPais = 0;

    // this.listarPais();
    // this.listarTipoDocumentoPais(0);

    // this.listarTipDocPN();
  }

  private buildForm() {
    this.form = this.fb.group({
      tipoDocumento: [2, Validators.required],
      documentoIdentidad: [null, Validators.required],
      clave: [null, Validators.required]
    });
  }

  listarPais = () => {
    this.usuariosService.listarPais(1).subscribe(data => this.paises = data.result
      //,error => console.log(error)
    );
  }

  handleChangePais(event) {
    this.listarTipoDocumentoPais(this.selectedPais);
  }

  listarTipoDocumentoPais = (idPais: number) => {
    this.selectedTipDocPais = 0;
    //jclr
    this.usuariosService.listarTipoDocumentoPais(idPais, 4).subscribe(data => this.tipoDocumentoPais = data.result
      //,error => console.log(error)
    );
  }

  listarTipDocPN = () => {
    this.selectTipDocPN = 0;
    //jclr
    this.usuariosService.listarTipoDocumentoPais(1, 2).subscribe(data => this.tipDocPN = data.result
      //,error => console.log(error)
    );
  }

  handleVisorP = (type) => {
    switch (type) {
      case 1: this.isTypeP1bol = !this.isTypeP1bol;
        if (this.isTypeP1bol) {
          this.isTypeP1 = "text";
        }
        else {
          this.isTypeP1 = "password";
        }
        break;
      case 2: this.isTypeP2bol = !this.isTypeP2bol;
        if (this.isTypeP2bol) {
          this.isTypeP2 = "text";
        }
        else {
          this.isTypeP2 = "password";
        }
        break;
      case 3: this.isTypeP3bol = !this.isTypeP3bol;
        if (this.isTypeP3bol) {
          this.isTypeP3 = "text";
        }
        else {
          this.isTypeP3 = "password";
        }
        break
    }
  }

  handleLogin = () => {
    if (this.datosUsuario.nroDocumento == "") {
      this.toast.error("Por favor ingrese el número de RUC");
    }
    // else if (this.datosUsuario.nroDocumento.length != 11) {
    //   this.toast.error("El RUC ingresado es incorrecto");
    // }
    else if (this.datosUsuario.clave == "") {
      this.toast.error("Por favor ingrese su contraseña");
    }
    else {
      this.loginPortalRequest = {
        pnTipo: 1,
        pnTipoDocumento: 120,
        pnPais: 104,
        pcNroDocumento: this.datosUsuario.nroDocumento,
        pcClave: this.encriptarClave(this.datosUsuario.clave)
      }
      //this.usuariosService.validarAcceso('1', '120', '104', this.datosUsuario.nroDocumento, this.encriptarClave(this.datosUsuario.clave)).subscribe((response) => {
      this.usuariosService.validarAcceso(this.loginPortalRequest).subscribe((response) => {
        debugger;
        if (response.pnTipo == 1) {
          this.casillaActual.setSesion(response.token);
          this.appStore.sessionAction.login(response.token);
          const sesion = this.casillaActual.getSesion();
          const sesion2 = this.appStore.sessionAction.getUserSesion();

          //console.log(this.appStore.sessionAction.getUserSesion());
          let token = this.appStore.sessionAction.isToken();
          location.href = this.urlReturn + "/?token=" + token;

        }
        else {
          this.toast.error(response.rptMsg);
        }
      });
    }
  }

  handleSigo = () => {
    if (this.errorRepcatcha)
      return;

    if (this.validateCaptcha()) {
      if (this.datosUsuario.nroDocumento == "") {
        this.toast.error("Por favor ingresa el usuario");
      }
      else if (this.datosUsuario.clave == "") {
        this.toast.error("Por favor ingresa tu contraseña");
      }
      else {
        // this.loading = true;
        this.isLoading = true;
        this.loginSigoRequest = {
          pcUsuario: this.datosUsuario.nroDocumento,
          pcClave: this.datosUsuario.clave,
          pTipo: environment.tipoAcceso
        }
        //this.usuariosService.validarAccesoSigo(this.datosUsuario.usuario, this.encriptarClave(this.datosUsuario.clave)).subscribe((response) => {
        //this.usuariosService.validarAccesoSigo(this.datosUsuario.usuario, this.datosUsuario.clave, environment.tipoAcceso).subscribe((response) => {
        this.usuariosService.validarAccesoSigo(this.loginSigoRequest).subscribe((response) => {
          if (response.rptTipo == 1 || response.rptTipo == 2) {
            this.casillaActual.setSesion(response.token);
            this.appStore.sessionAction.login(response.token);
            const sesion = this.casillaActual.getSesion();
            const sesion2 = this.appStore.sessionAction.getUserSesion();

            //console.log(this.appStore.sessionAction.getUserSesion());
            //let token = this.route.snapshot.queryParamMap.get('token');
            let token = this.appStore.sessionAction.isToken();
            //location.href = "http://sifirmademo.pvn.gob.pe/?token=" + token; //environment.loginUrl + window.location.origin;
            location.href = this.urlReturn + "/?token=" + token;
            // this.loading = false;
            this.isLoading = false;
          }
          else {
            // this.loading = false;
            this.isLoading = false;
            this.toast.error(response.rptMsg);
          }
        });
      }
    }
  }

  handleLoginEX = () => {
    if (this.selectedPais == 0) {
      this.toast.error("Por favor selecciona país");
    }
    else if (this.selectedTipDocPais == 0) {
      this.toast.error("Por favor seleccione Tipo de Documento");
    }
    else if (this.datosUsuario.nroDocumento == "") {
      this.toast.error("Por favor ingrese el número de documento");
    }
    else if (this.datosUsuario.clave == "") {
      this.toast.error("Por favor ingrese su contraseña");
    }
    else {
      this.loginPortalRequest = {
        pnTipo: 3,
        pnTipoDocumento: this.selectedTipDocPais,
        pnPais: this.selectedPais,
        pcNroDocumento: this.datosUsuario.nroDocumento,
        pcClave: this.encriptarClave(this.datosUsuario.clave)
      }
      //this.usuariosService.validarAcceso('3', this.selectedTipDocPais.toString(), this.selectedPais.toString(), this.datosUsuario.nroDocumento, this.encriptarClave(this.datosUsuario.clave)).subscribe((response) => {
      this.usuariosService.validarAcceso(this.loginPortalRequest).subscribe((response) => {
        if (response.rptTipo == 1 || response.rptTipo == 2) {
          this.casillaActual.setSesion(response.token);
          this.appStore.sessionAction.login(response.token);
          const sesion = this.casillaActual.getSesion();
          const sesion2 = this.appStore.sessionAction.getUserSesion();

          //console.log(this.appStore.sessionAction.getUserSesion());
          let token = this.appStore.sessionAction.isToken();
          // location.href = this.urlReturn + "/?token=" + token;

        }
        else {
          this.toast.error(response.rptMsg);
        }
      });
    }
  }

  RegistrarUsuario = () => {
    //window.location.replace('https://sgdqa.pvn.gob.pe/Usuario/NuevaCuentaMesaVirtual');
    window.open('https://sgd.pvn.gob.pe/Usuario/NuevaCuentaMesaVirtual', "_blank");
  }

  RecuperarContraseniaUsuario = () => {
    window.open('https://sgd.pvn.gob.pe', "_blank");
  }

  handleLoginPN = () => {
    if (this.datosUsuario.nroDocumento == "") {
      this.toast.error("Por favor ingrese el número de documento");
    }
    else if (this.selectTipDocPN == 2 && this.datosUsuario.nroDocumento.length != 8) {
      this.toast.error("El DNI ingresado es incorrecto");
    }
    else if (this.datosUsuario.clave == "") {
      this.toast.error("Por favor ingrese su contraseña");
    }
    else {
      this.loginPortalRequest = {
        pnTipo: 2,
        pnTipoDocumento: this.selectTipDocPN,
        pnPais: 104,
        pcNroDocumento: this.datosUsuario.nroDocumento,
        pcClave: this.encriptarClave(this.datosUsuario.clave)
      }
      //this.usuariosService.validarAcceso('2', '2', '104', this.datosUsuario.nroDocumento, this.encriptarClave(this.datosUsuario.clave)).subscribe((response) => {
      this.usuariosService.validarAcceso(this.loginPortalRequest).subscribe((response) => {
        console.log(response)
        if (response.rptTipo == 1 || response.rptTipo == 2) {
          this.casillaActual.setSesion(response.token);
          this.appStore.sessionAction.login(response.token);
          const sesion = this.casillaActual.getSesion();
          const sesion2 = this.appStore.sessionAction.getUserSesion();
          //console.log(this.appStore.sessionAction.getUserSesion());
          let token = this.appStore.sessionAction.isToken();
          location.href = this.urlReturn + "/?token=" + token;

        }
        else {
          this.toast.error(response.rptMsg);
        }
      });
    }
  }

  encriptarClave = (dato: string): string => {
    return CryptoJS.MD5(dato).toString();
  };

  makeRandom(lengthOfCode: number, possible: string) {
    let text = "";
    for (let i = 0; i < lengthOfCode; i++) {
      text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return text;
  }

  generateCaptcha() {
    let possible = "1234567890"
    const lengthOfCode = 1

    for (let i = 0; i < this.VALOR_MAXIMO_REPCATCHA; i++) {
      let captchaChar = this.makeRandom(lengthOfCode, possible)
      this.captchaText[i] = captchaChar
    }

    this.captchaTextNumber = this.shuffleArray(this.captchaTextNumber);
    // for (let i = 0; i < 10; i++) {
    //   let captchaChar = this.makeRandom(lengthOfCode, possible)
    //   this.captchaTextNumber[i] = captchaChar
    // }
  }

  validateCaptcha() {
    let i = 0
    this.captchaEntered = this.captchaEnteredArray.join('').toLocaleUpperCase()

    if (this.captchaEnteredArray.length < this.VALOR_MAXIMO_REPCATCHA) {
      this.toast.error("Digite el número por favor");
      return false;
    }

    for (i; i < this.captchaEnteredArray.length; i++) {
      if (this.captchaEntered.charAt(i) != this.captchaText[i]) {
        this.textoErrorRepcatcha = this.textoErrorRepcatcha + ' - Vuélvelo a intentar';
        this.errorRepcatcha = true;
        return false
      }
    }

    return true;
  }

  shuffleArray(inputArray: []) {
    inputArray.sort(() => Math.random() - 0.5);

    return inputArray;
  }


  handleActionButton(event, value) {
    if (!this.errorRepcatcha) {
      if (this.captchaEnteredArray.length < this.VALOR_MAXIMO_REPCATCHA) {
        const box = document.getElementById(event);
        box.classList.add('active');
        this.captchaEnteredArray.push(value);
        this.textoErrorRepcatcha = this.captchaEnteredArray.join('');
      }
    } else {
      if (this.captchaEnteredArray.length < this.VALOR_MAXIMO_REPCATCHA) {
        this.errorRepcatcha = false;
      }
    }
  }

  handleActionRefresh() {
    for (let x = 0; x < 10; x++) {
      let box = document.getElementById(x + '_repcatcha');
      box.classList.remove('active');
    }

    this.captchaEnteredArray = [];
    this.textoErrorRepcatcha = "";

    this.generateCaptcha();
  }

  // private buscarCasillaPorDocumento = (tipoDocumento, documentoIdentidad) => {
  //   this.casillaService.buscarCasillaPorDocumento(tipoDocumento, documentoIdentidad)
  //     .subscribe((casilla) => {
  //       console.log('responseCasilla', casilla);

  //       let casillaActiva = false;

  //       if(casilla && casilla.fK_eIdEstadoCasilla == this.ESTADOCASILLA.ACTIVO)
  //       {
  //         this.casillaActual.setCasillaActual(casilla);
  //         casillaActiva = true;
  //       }

  //       this.router.navigate(['/home/']);

  //       // if(casillaActiva) {
  //       //   this.router.navigate(['/home/']);
  //       // } else {
  //       //   this.casillaActual.limpiarSesion();
  //       //   location.href = environment.loginUrl + window.location.origin + '&msgError=No se encontró la casilla o la misma no esta Activa';
  //       // }
  //     });
  // }

}
